import { createAsyncAction } from 'typesafe-actions';
import { HttpStatus } from 'client/ErrorHandler';
import {
  FileGenerationTypes,
  FileGenerationRequestActionPayload,
} from './types';

const exportsActions = createAsyncAction(
  FileGenerationTypes.FileGenerationRequest,
  FileGenerationTypes.FileGenerationSuccess,
  FileGenerationTypes.FileGenerationFailure
)<FileGenerationRequestActionPayload, undefined, HttpStatus>();

export default exportsActions;
